export const SET_LICENSES = 'SET_LICENSES';
export const setLicensesAction = (licenses) => ({
  type: SET_LICENSES,
  payload: licenses,
});
